// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"menu_wrapper_NiZ-h","menu":"menu_menu_25F5q","tab":"menu_tab_3hyYK","active":"menu_active_e5pD_","container":"menu_container_3WWfO"};